import { HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ReCaptchaV3Service} from 'ng-recaptcha-2';
import {Observable, map, catchError, of} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaHelperService {
  constructor(private recaptchaV3Service: ReCaptchaV3Service) {}
  /**
   * @description Ottiene il token da inviare al backend
   * @returns token (string) o stringa vuota in caso di error
   */
  public getToken(): Observable<string> {
    return this.recaptchaV3Service.execute('recaptcha_initialize').pipe(
      // map((reCAPTCHAToken: string) => {
      //   return reCAPTCHAToken;
      // }),
      catchError((err: HttpErrorResponse) => {
        console.error(err);
        return of(err.error);
      }),
    );
  }
}
